import React from 'react';
import { DefaultPieChartColors, SWUpdateStatuses } from '../../../../common/utils/constants';
import { Chart } from '../../../shared/Chart';
import styles from './SWUpdateStatusChart.module.css';

const doughnutChartOptions = {
  cutout: '35%',
  maintainAspectRatio: false,
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    crosshair: {
      display: false,
    }
  },
};

const swUpdateStatusNames = {
  [SWUpdateStatuses.COMPLETED]: 'Completed',
  [SWUpdateStatuses.SCHEDULED]: 'Scheduled',
  [SWUpdateStatuses.DOWNLOADING]: 'Downloading',
  [SWUpdateStatuses.REBOOTING]: 'Rebooting',
  [SWUpdateStatuses.ERROR]: 'Error',
  [SWUpdateStatuses.QUEUEING]: 'Queueing',
  [SWUpdateStatuses.WARNING]: 'Warning',
  [SWUpdateStatuses.SCHEDULED_ACTIVATION]: 'Scheduled Activation',
};
const swUpdateStatuses = Object.values(SWUpdateStatuses);
const defaultStatusCount = swUpdateStatuses.reduce((acc, status) => {
  acc[status] = 0;

  return acc;
}, {});

function SWUpdateStatusChart({ devices }) {
  const statusCounts = devices.reduce((acc, device) => {
    const { status } = device.upgrade_status;

    if (!acc[status]) {
      acc[status] = 0;
    }

    acc[status] += 1;

    return acc;
  }, { ...defaultStatusCount });
  const data = {
    labels: swUpdateStatuses,
    datasets: [
      {
        label: 'Software Update Status',
        data: swUpdateStatuses.map((status) => statusCounts[status]),
        backgroundColor: DefaultPieChartColors,
      },
    ],
  };

  return (
    <div className={styles.root}>
      <div className={styles.chart}>
        <div className={styles.chartTitle}> Progress chart: </div>
        <div className={styles.chartContainer}>
          <Chart type="doughnut" data={data} options={doughnutChartOptions} />
        </div>
      </div>
      <div className={styles.legend}>
        {swUpdateStatuses.map((status, index) => (
          <div key={status} className={styles.legendItem}>
            <div
              className={styles.legendItemPoint}
              style={{ backgroundColor: DefaultPieChartColors[index] }}
            />
            <div className={styles.legendItemLabel}>
              <div className={styles.legendItemLabelCount}>
                {statusCounts[status] ? `${Math.round(statusCounts[status] / devices.length * 100)}%` : '0%'}
              </div>
              <div className={styles.legendItemLabelName}>
                {' '}{swUpdateStatusNames[status]}{' '}
              </div>
            </div>
          </div>
        ))}
        <div className="legendItem"></div>
      </div>
    </div>
  );
}

export default SWUpdateStatusChart;
